// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select} from '@ngrx/store';
import { Observable, filter, map, take, withLatestFrom } from 'rxjs';
import { authPortalUserState, currentTenantDataState } from '../app-states/app.state';
import { LoadCurrentTenantPricingPlans, LoadCurrentTenantSubTenants } from '../app-states/actions/app.actions';

@Injectable({
  providedIn: 'root'
})
export class SubTenantsAreaGuard  {

  constructor(private store: Store, private router: Router) {

  }

  canActivate(): Observable<boolean> {
    return this.store.pipe(select(authPortalUserState)).pipe(
      filter(authUserState => authUserState.status === 'loaded'),
      take(1),
      withLatestFrom(this.store.pipe(select(currentTenantDataState))),
      map(([authUserState, tenantData]) => {
      
        if (authUserState.currentTenantId && authUserState.authUser) {
          if (authUserState.authUser.canManageSubTenants(authUserState.currentTenantId)) {
            const currentTenantProfile = authUserState.authUser.getTenantProfile(authUserState.currentTenantId);
            const isPrepaidTenant = currentTenantProfile?.billingType?.toLowerCase() === 'prepaid';

            if (tenantData.subTenantsStatus !== 'loading') {
              this.store.dispatch(LoadCurrentTenantSubTenants({ payload: undefined }));
            }
            if (!isPrepaidTenant && tenantData.pricingPlansStatus !== 'loading') {
              this.store.dispatch(LoadCurrentTenantPricingPlans({ payload: undefined }));
            }
            return true;
          } else {
            this.router.navigate(['userSettings'])
            return false;
          }
        } else {
          this.router.navigate(['userSettings'])
          return false;
        }
      })
    )
  }

}
